var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bet-creator-ratios" }, [
    _c("div", { staticClass: "header-bar" }, [
      _c("span", { staticClass: "title-text" }, [_vm._v(" 输入金额 ")]),
      _c(
        "button",
        {
          staticClass: "toggle-editor-btn",
          attrs: { type: "button" },
          on: { click: _vm.toggleEditor },
        },
        [
          _c("i", {
            staticClass: "icon",
            class: _vm.editorOpened ? "icon_close-bold" : "icon_gear-bold",
          }),
        ]
      ),
    ]),
    _c(
      "div",
      {
        staticClass: "control-wrapper",
        class: { "is-disabled": _vm.disabled },
      },
      [
        _c("div", { staticClass: "input-container" }, [
          _c("i", { staticClass: "icon icon_coin-bold coin-icon" }),
          _c("input", {
            staticClass: "bet-input",
            attrs: {
              disabled: _vm.disabled,
              type: "number",
              step: "0.01",
              min: "0.25",
              placeholder: "0.25",
            },
            domProps: { value: _vm.currentBetAmount },
            on: { input: _vm.onBetAmountInput, blur: _vm.onBetAmountBlur },
          }),
        ]),
        !_vm.editorOpened
          ? _c(
              "div",
              { staticClass: "fast-amounts-group" },
              [
                _vm._l(_vm.fastAmounts, function (amount) {
                  return _c(
                    "button",
                    {
                      key: amount,
                      staticClass: "fast-btn",
                      class: { "is-selected": _vm.isAmountSelected(amount) },
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.setFastAmount(amount)
                        },
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "icon icon_coin-bold fast-coin-icon",
                        class: { "is-active": _vm.isAmountSelected(amount) },
                      }),
                      _c(
                        "span",
                        {
                          staticClass: "fast-amount-text",
                          class: { "is-active": _vm.isAmountSelected(amount) },
                        },
                        [_vm._v(" " + _vm._s(amount) + " ")]
                      ),
                    ]
                  )
                }),
                _c(
                  "button",
                  {
                    staticClass: "fast-btn max-btn",
                    class: { "is-selected": _vm.isMaxBet },
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.setFastAmount("max")
                      },
                    },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "fast-amount-text",
                        class: { "is-active": _vm.isMaxBet },
                      },
                      [_vm._v(" Max ")]
                    ),
                  ]
                ),
              ],
              2
            )
          : _c(
              "div",
              { staticClass: "editor-group" },
              [
                _vm._l(_vm.editableAmounts, function (amount, index) {
                  return _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.number",
                        value: _vm.editableAmounts[index],
                        expression: "editableAmounts[index]",
                        modifiers: { number: true },
                      },
                    ],
                    key: index,
                    staticClass: "editor-input",
                    class: {
                      "is-invalid": _vm.isAmountInvalid(
                        _vm.editableAmounts[index]
                      ),
                    },
                    attrs: {
                      type: "number",
                      autocomplete: "off",
                      disabled: _vm.disabled,
                    },
                    domProps: { value: _vm.editableAmounts[index] },
                    on: {
                      input: [
                        function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.editableAmounts,
                            index,
                            _vm._n($event.target.value)
                          )
                        },
                        _vm.onEditableAmountInput,
                      ],
                      blur: function ($event) {
                        return _vm.$forceUpdate()
                      },
                    },
                  })
                }),
                _c(
                  "button",
                  {
                    staticClass: "confirm-btn",
                    attrs: { type: "button" },
                    on: { click: _vm.toggleEditor },
                  },
                  [_c("i", { staticClass: "icon icon_check check-icon" })]
                ),
              ],
              2
            ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }